//let DECLUSTER_ENABLED: boolean = false;  // AWH TODO put this in the datastore and make it a debug setting

import * as _ from "lodash";  // awh todo - remove this dependency
import { Point } from '../Point'
import { Rectangle } from '../Rectangle'
import { Id_asset, Id_category, Id_floor, Id_workorder, Id_location } from '../api/Identifiers'
import { Category, CategoryCollection } from '../Categories'
import { Translate, Distance, Nudge } from '../Geometry'
import { exists } from "../utils";

//import { Map, fromJS } from 'immutable'

interface AssetJSON {
    adj_coords: number[];
    adjP1P2: any[];
    category: number;
    coords: number[];
    icon: string;
    id_asset: string;   // id_asset is a UUID
    id_location: number;
    id_floor: number;
    rawCoords: number[];
    rawP1P2: number[];
    has_coords: boolean;
}

export class Asset {
    private _raw_coord: Point;
    private _adj_coord: Point;
    private _raw_geoRef: Rectangle;
    private _adj_geoRef: Rectangle;
    private _icon: string;
    private _id: Id_asset;
    private _category: string;
    private _id_category: Id_category = null;
    private _id_location: Id_location;
    private _id_floor: Id_floor;
    private _raw: any;
    private _has_coords: boolean = true;
    //    get id_location(): Id_location { return this._id_location; }
    get id_floor(): Id_floor {
        if (!this._id_floor) {
            return this._id_location;
        }
        return this._id_floor;
    }

    public get id(): Id_asset {
        return this._id;
    }

    public set_category(categories: CategoryCollection) {
        this._category = categories.find(this._id_category).label
    }

    public get category(): string {
        return this._category;
    }

    public get coord(): Point {
        let ret_val: Point = this._adj_coord;
        if (!ret_val) {
            ret_val = this._raw_coord;
        }
        return ret_val;
    }

    private get adj_coord(): Point {
        let ret_val: Point = this._adj_coord;
        if (!ret_val) {
            ret_val = this.raw_coord;
            if (!ret_val) {
                ret_val = Point.NULL;
            }
        }
        return ret_val;
    }

    private get adj_geoRef(): Rectangle {
        let ret_val: Rectangle = this._adj_geoRef;
        if (!ret_val) {
            ret_val = this._raw_geoRef;
            if (!ret_val) {
                ret_val = Rectangle.NULL;
            }
        }
        return ret_val;
    }

    private get raw_coord(): Point {
        if (!this._has_coords) {
            // pass
            return Point.build(5000, 5000);
        }

        return this._raw_coord;

    }
    public get id_category(): Id_category {
        return this._id_category;

    }

    public is_valid(): boolean {
        if (this._raw_coord.X) {
            if (this._raw_coord.Y) {
                if (this._icon) {
                    if (this._icon !== "") {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    public translate_asset(drawing_p1p2: Rectangle, p0: Point): void {
        if (drawing_p1p2) {
            if (!this._has_coords) {
                // if this asset has no coords, set the adj coord to the provided p0
                this._adj_coord = p0;
                this._adj_geoRef = drawing_p1p2;

            } else {
                this._adj_coord = Translate(this.raw_coord, this._raw_geoRef, drawing_p1p2);
                this._adj_geoRef = drawing_p1p2;
            }
        }
    }

    public get raw(): any {
        return this._raw;
    }

    public static build_from_raw(raw_asset: any, categories?: CategoryCollection): Asset {

        let r: Asset = new Asset
        if (raw_asset.asset) {
            // sometimes the raw asset is buried under an asset field
            raw_asset = raw_asset.asset
        }
        r._raw = Object.assign({}, raw_asset);

        r._id = Id_asset.wrap(raw_asset.id)
        if (!r._id) {
            r._id = Id_asset.wrap(raw_asset.idAsset)
        }
        if (!r._id) {
            console.debug(`asset is missing an id field`)
            return null;
        }
        r._id_category = Id_category.wrap(raw_asset.idCategory);
        if (!r._id_category) {
            console.debug("Asset" + r._id.toString() + " is missing required idCategory field.")
            return null;
        }
        r._category = r._id_category.toString();
        r._id_location = Id_location.wrap(raw_asset.idLocation);
        r._id_floor = Id_floor.wrap(raw_asset.idFloor);
        r._raw_coord = Point.build(raw_asset.xCoord, raw_asset.yCoord);
        if (!r._raw_coord) {
            r._raw_coord = Point.build(5000, 5000);
            r._has_coords = false;
        }
        else {
            if (r._raw_coord.X === 0 && r._raw_coord.Y === 0) {
                r._has_coords = false;
            }
            if (r._raw_coord.X === 500 && r._raw_coord.Y === 500) {
                r._has_coords = false;
            }
            if (r._raw_coord.X === 5000 && r._raw_coord.Y === 5000) {
                r._has_coords = false;
            }
        }
        if (categories) {
            r.set_category(categories);
        }

        r._icon = utilsAssetIcon(raw_asset.icon);

        if (!r._icon) {
            r._icon = utilsAssetIcon(raw_asset.cmsViewIcon);
        }

        if (raw_asset.p1xCoord in raw_asset){
            r._raw_geoRef = Rectangle.build_from_numbers(raw_asset.p1xCoord,
                raw_asset.p1yCoord,
                raw_asset.p2xCoord,
                raw_asset.p2yCoord)    
        }
        else{
            r._raw_geoRef = Rectangle.build_from_numbers(raw_asset.p1XCoord,
                raw_asset.p1YCoord,
                raw_asset.p2XCoord,
                raw_asset.p2YCoord)
        }

        if (!r._raw_geoRef) {
            // awh todo: reject this asset. don't store it
            r._raw_geoRef = Rectangle.NULL;
        }
        return r;
    }

    public get has_coords(): boolean { return this._has_coords; }

    public toJSON(): AssetJSON {
        const r: AssetJSON = {
            adj_coords: this.adj_coord.toJSON(),
            adjP1P2: this.adj_geoRef.toJSON(),
            coords: this.adj_coord.toJSON(),
            category: this._id_category.value,
            icon: this._icon,
            id_asset: this._id.value,
            id_location: this.id_floor.value,  // AWH - reconcile this
            id_floor: this.id_floor.value,
            rawCoords: this.raw_coord.toJSON(),
            rawP1P2: this._raw_geoRef.toJSON(),
            has_coords: this.has_coords
        };
        return r
    }

    public nudge(rhs: Asset): void {
        if (this.category === rhs.category) {
            // only nudge if the assets are the same category
            if (this.id_floor.equals(rhs.id_floor)) {
                // only nudge if the assets are on the same floor

                if (!this.id.equals(rhs.id)) {
                    // only nudge if the ids don't match
                    if (this._adj_coord) {
                        if (rhs._adj_coord) {
                            Nudge(this._adj_coord, rhs._adj_coord, 45, 20);
                        }
                    }
                }
            }
        }
    }
}



export class AssetCollection {

    private _assets: any = {};  // {id_asset:Asset}
    private _assets_sorted_by_floor: any = {};   //{(key:string):Id_asset[]} = null;
    private __assets_list: Asset[] = null;  // {id_asset:Asset}
    private __json: any = null;
    //private __assets_sorted_by_floor_json: any = null;

    public static empty(): AssetCollection { return new AssetCollection(); };


    public constructor() {

    }

    public get count(): number {
        return this.assets.length;
    }
    public get assets(): Asset[] {

        if (!this.__assets_list) {
            this.__assets_list = []
            Object.keys(this._assets).forEach((id_asset: string) => {
                this.__assets_list.push(this._assets[id_asset]);
            })
        }
        return this.__assets_list;
    }

    public get_asset(id_asset: Id_asset): Asset {
        let r: Asset = this._assets[id_asset.value];
        if (!r) {
            return null;
        }
        return r;
    }


    public get_assets_on_floor(id_floor: Id_floor): AssetCollection {
        let r: AssetCollection = new AssetCollection();
        this.assets.forEach((asset: Asset) => {
            if (asset.id_floor.equals(id_floor)) {
                r.add_asset(asset);
            }
        })
        return r;
    }


    public get length(): number {
        return Object.keys(this._assets).length;
    }

    public static build_from_raw(raw_assets: any[]): Asset[] {
        let r: Asset[] = [];
        raw_assets.forEach((raw_asset: any) => {
            let new_asset: Asset = Asset.build_from_raw(raw_asset)
            if (new_asset) {
                r.push(new_asset);
            }
            else {
                console.error(`null asset created by ${raw_asset}`)
            }
        })
        return r;
    }



    public static wrap(assets: Asset[]): AssetCollection {
        let r: AssetCollection = new AssetCollection();
        assets.forEach((asset: any) => {
            r.add_asset(asset);
        })
        return r;
    }

    public add_assets(assets: Asset[]) {
        assets.forEach((asset: Asset) => this.add_asset(asset));
    }

    private add_asset(asset: Asset) {

        this._assets[asset.id.value] = asset;

        // add the asset to the floor-sorted table
        if (!this._assets_sorted_by_floor[asset.id_floor.toString()]) {
            this._assets_sorted_by_floor[asset.id_floor.toString()] = [];
        }
        this._assets_sorted_by_floor[asset.id_floor.toString()].push(asset.id);

        this.__json = null;
        //     this.__assets_sorted_by_floor_json = null;
        this.__assets_list = null;
    }

    public get_assets_by_category(category: Category): Asset[] {
        return this.assets.filter((asset: Asset) => asset.id_category.equals(category.id_category));
    }

    public get_categories(): string[] {
        let mySet = new Set<string>();
        this.assets.forEach((asset: Asset) => mySet.add(asset.id_category.toString()));
        return Array.from(mySet);
    }

    public toJSON(): any {
        if (this.__json === null) {
            this.__json = JSON.parse(JSON.stringify(Object.keys(this._assets)));
        }
        return this.__json;
    }

    // assume the asset contains adj_coords
    private declusterAssets(id_location: Id_location) {
        let declusterCore = () => {
            this.assets.forEach((lhs: Asset) => {

                if (!lhs.id_floor.equals(id_location)) {
                    return
                }

                if (!lhs.has_coords) {
                    return;
                }
                this.assets.forEach((rhs: Asset) => {
                    if (!rhs.has_coords) {
                        return;
                    }
                    if (lhs.category == rhs.category) {
                        // only perform decluster of assets that are the same category
                        if (lhs.id.equals(rhs.id)) {
                            // lhs and rhs are the same. ignore
                        }
                        else {
                            lhs.nudge(rhs)
                        }
                    }
                })
            })
        }

        // run the decluster algorithm multiple times
        declusterCore();
        declusterCore();
    }

    public translate_assets(drawing_p1p2: Rectangle, id_location: Id_location, p0: Point, nudge_overlapping: boolean) {
        if (exists(drawing_p1p2)) {
            this.assets.forEach((asset: Asset) => {
                if (asset.id_floor.equals(id_location)) {
                    asset.translate_asset(drawing_p1p2, p0);
                    //       this.__assets_sorted_by_floor_json = null;
                }
            });
            if (nudge_overlapping) {
                this.declusterAssets(id_location);
            }
        }
    }

    // returns a JSON object of all assets indexed by floor
    public sorted_by_floor_json(): any {

        //     if (this.__assets_sorted_by_floor_json === null) {
        //         this.__assets_sorted_by_floor_json = {}
        let __assets_sorted_by_floor_json: any = {}
        this.assets.forEach((asset: Asset) => {
            let id_location: string = asset.id_floor.toString();
            if (!__assets_sorted_by_floor_json[id_location]) {
                __assets_sorted_by_floor_json[id_location] = []
            }
            __assets_sorted_by_floor_json[id_location].push(asset.toJSON());
        })

        return __assets_sorted_by_floor_json;
    }
}

/*
{
    "81084": {
      "0e8b6378-3a93-48d3-8def-c70c6a6278b8": {
        "adj_coords": [
          2305.591762,
          11923.19814
        ],
        "rawCoords": [
          2305.591762,
          11923.19814
        ],
 
        "id_floor": 81084,
        "adjP1P2": [
          [
            457.5,
            11846.5
          ],
          [
            13936.5,
            5282.5
          ]
        ],
        "rawP1P2": [
          [
            null,
            null
          ],
          [
            null,
            null
          ]
        ],
        "id_asset": "0e8b6378-3a93-48d3-8def-c70c6a6278b8",
        "idAsset": "0e8b6378-3a93-48d3-8def-c70c6a6278b8",
        "icon": "https://portalvhdsc1clt6c22szhn.blob.core.windows.net:443/cmsview/icons/48/exit.png",
        "assetNumber": "LSM707521",
        "idCategory": 251,
        "yCoord": 11923.19814,
        "xCoord": 2305.591762
      }
      */

function utilsAssetIcon(cms_view_icon: string): string {
    if (!exists(cms_view_icon)) {
        return "";
    }
    let icon: string = cms_view_icon

    if (icon.toLowerCase().substring(0, 4) !== "http") {
        icon = "https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/icons/48/" + icon
    }
    return icon
}



// WEBPACK FOOTER //
// ./src/ts/assets/Asset.ts